export interface User {
    id: number;
    name: string;
    email: string;
    avatar?: string;
    status?: string;
    // Null for platform-level users (SuperAdmin), who belong to no society.
    societyId: number | null;
    societyName?: string;
    roleName: string;
    flatId?: number;
    flatNumber?: string;
    flatOwnerId?: number;
    wingId?: number;
    wingName?: string;
    canManageCommonAccount?: boolean;
    membershipId?: number;
    sessionId?: string;
    memberships?: LoginMembership[];
}

/** A selectable society/flat account context returned by the auth API. */
export interface LoginMembership {
    membershipId: number;
    societyId: number;
    societyName?: string;
    flatId?: number | null;
    flatNumber?: string | null;
    wingId?: number | null;
    wingName?: string | null;
    roleName?: string | null;
    canManageCommonAccount?: boolean;
    isPrimary?: boolean;
    isActive: boolean;
}

export const ADMIN_ROLE = 'Admin';
export const SUPER_ADMIN_ROLE = 'SuperAdmin';

export interface LoginRequest {
    email: string;
    password: string;
}

export interface LoginResponse {
    token: string;
    userId: number;
    email: string;
    fullName: string;
    societyId: number | null;
    societyName?: string;
    roleName: string;
    isAdmin: boolean;
    flatId?: number;
    flatNumber?: string;
    flatOwnerId?: number;
    wingId?: number;
    wingName?: string;
    canManageCommonAccount?: boolean;
    sessionId?: string;
    membershipSelectionRequired?: boolean;
    memberships?: LoginMembership[];
    activeMembership?: LoginMembership | null;
}

export interface ChangePasswordRequest {
    oldPassword: string;
    newPassword: string;
}

export interface DashboardDto {
    isActive?: boolean;
    societyName: string;
    totalFlats: number;
    occupiedFlats: number;
    totalWings: number;
    totalIncomeThisMonth: number;
    cashIncomeThisMonth: number;
    onlineIncomeThisMonth: number;
    totalExpensesThisMonth: number;
    totalDiscountThisMonth: number;
    netBalanceThisMonth: number;
    totalIncomeAllTime: number;
    cashIncomeAllTime: number;
    onlineIncomeAllTime: number;
    totalExpensesAllTime: number;
    totalDiscountAllTime: number;
    netBalanceAllTime: number;
    cashInHand?: number;
    bankBalances?: BankBalanceDto[];
    commonPool?: CommonPoolDashboardDto | null;
    pendingDuesFlats: PendingDuesFlatDto[];
    wingStatistics: WingDashboardDto[];
}

export interface BankBalanceDto {
    bankAccountId: number;
    wingId?: number | null;
    accountName: string;
    bankName: string;
    openingBalance: number;
    balance: number;
}

export interface CommonPoolDashboardDto {
    cashInHand: number;
    banks: BankBalanceDto[];
}

export interface PendingDuesFlatDto {
    flatId: number;
    flatNumber: string;
    wingName: string;
    ownerName: string;
    pendingAmount: number;
}

export interface WingDashboardDto {
    wingId: number;
    wingName: string;
    totalFlats: number;
    occupiedFlats: number;
    totalIncomeThisMonth: number;
    totalExpensesThisMonth: number;
    cashInHand?: number;
}
